import { useState } from 'preact/hooks';
import { useShallow } from 'zustand/shallow';
import AuthenticatedPage from '../../components/authenticated-page';
import { EpisodeItem } from '../../components/episode-item';
import {
  idbStartupCompleteSignal,
  idToEpisode,
  usePodcastsStore,
} from '../../global-state/podcasts';
import { useUserDataStore } from '../../global-state/user-data';
import { isOnServer } from '../../utils/helpers';
import { usePageTitle } from '../../utils/page-title';

export default function ListeningHistory() {
  usePageTitle('Listening History');
  const allListenedToEpisodeIds = useUserDataStore((s) => s.recentEpisodeIds);
  const progressSaveTimes = useUserDataStore((s) => s.episodesProgressSaveTimes);
  const [maxEpisodes, setMaxEpisodes] = useState(100);
  const recentEpisodeIds = allListenedToEpisodeIds.slice(0, maxEpisodes);

  // Re-render when recent episodes change
  const recentEpisodes = usePodcastsStore(
    useShallow(() => recentEpisodeIds.map((id) => idToEpisode(id)))
  );

  const episodesNotShownCount =
    allListenedToEpisodeIds.length - recentEpisodeIds.length;

  let lastMonthAndYear = '';

  return (
    <AuthenticatedPage>
      <section class="top-section">
        <h1 class="mb-1 text-xl">Listening History</h1>
        {!recentEpisodeIds.length && !isOnServer ? (
          <p>No episodes have been listened to</p>
        ) : !idbStartupCompleteSignal.value ? (
          <p>Loading...</p>
        ) : (
          recentEpisodes.map((episode) => {
            if (!episode) return;

            const savedAt = progressSaveTimes[episode.id];
            let monthAndYear = '';
            if (savedAt) {
              monthAndYear = new Date(savedAt).toLocaleString('default', {
                month: 'long',
                year: 'numeric',
              });
              if (lastMonthAndYear === monthAndYear) monthAndYear = '';
              else lastMonthAndYear = monthAndYear;
            }

            return (
              <>
                {monthAndYear && (
                  <h2 class="sticky top-12 z-[1] block w-full bg-white pb-2 pt-3">
                    {monthAndYear}
                  </h2>
                )}
                {episode ? (
                  <EpisodeItem episode={episode} key={episode.id}></EpisodeItem>
                ) : (
                  <div class="mb-2 flex h-32 items-center rounded border border-dashed border-gray-200 p-4">
                    Loading...
                  </div>
                )}
              </>
            );
          })
        )}
        {episodesNotShownCount > 100 ? (
          <button
            onClick={() => setMaxEpisodes(maxEpisodes + 100)}
            class="button button--transparent m-auto mt-8 w-40"
          >
            Show next 100
          </button>
        ) : episodesNotShownCount > 0 ? (
          <button
            onClick={() => setMaxEpisodes(maxEpisodes + 100)}
            class="button button--transparent m-auto mt-8 w-40"
          >
            Show remaining {episodesNotShownCount}
          </button>
        ) : (
          ''
        )}
      </section>
    </AuthenticatedPage>
  );
}
